module.exports = __webpack_public_path__ + "static/a-return-to-love-430a1cb219ef36efb179c9479d3b7563.jpg";